import { ApplicationConfig, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LanguageService } from './core/services/language.service';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { authCredentialsInterceptor } from './core/interceptors/auth-credentials.interceptor';
import { AuthStore } from './core/stores/auth.store';
import { provideQuillConfig } from 'ngx-quill/config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authCredentialsInterceptor, httpErrorInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'de',
      lang: 'de',
    }),
    provideAppInitializer(() => {
      inject(LanguageService);
    }),
    // Blocks the first navigation so guards see the session restored from the cookie.
    provideAppInitializer(() => inject(AuthStore).loadSession()),
    provideQuillConfig({}),
  ],
};
